import { render, staticRenderFns } from "./ShopSelect.vue?vue&type=template&id=6859ca5c"
import script from "./ShopSelect.vue?vue&type=script&lang=js"
export * from "./ShopSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports